<template functional>
  <div :class="['notice-card', data.class]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'NoticeCard'
};
</script>

<style lang="scss">
@include b(notice-card) {
  border: none!important;
  --notice-card-title-weight: var(--weight-font-icon);
  // padding-right: 16px!important;
  padding:16px 16px 16px 18px !important;
  &:not(.notice-import):before {
    content: "";
    height: 100%;
    width: 4px;
    position: absolute;
    left: 0;
    top: 0;
    background-color: #0EAD58;
  }
  &.zk-right-recorder-notice-card:before, &.project-collaborator-notice-card:before{
    background-color: var(--primary-color);
  }
  // &.notice-import:before{
  //   background-color: transparent;
  // }
  .el-notification__content{
    margin-top: 8px;
    line-height: 22px;
  }
  .el-notification__group {
    width: 100%;
    margin: 0;
  }
  .el-notification__title {
    // color: #0EAD69;
    color: var(--font-color-1);
    font-size: var(--size-font-7);
    // font-weight: var(--weight-font-Blod);
    font-weight: var(--notice-card-title-weight);
    line-height: 22px;
  }
  .el-button {
    .zkicon {
      font-size: 14px;
    }
  }
  .el-button--plaintext2{
    .zkicon {
      font-size: 14px;
    }
  }
  .el-notification__content {
    text-align: left;
  }
  .el-notification__closeBtn {
    font-size: var(--size-font-5);
    top: 13px;
    &:hover {
      color: var(--primary-color);
    }
  }
  .el-notification__icon {
    display: none;
  }
}
</style>
